/* @flow */
import React from 'react';
import humanparser from 'humanparser';
import Session from 'entities/Session';
import ToastActions from 'actions/ToastActions';
import PromptActions from 'actions/PromptActions';
import LinkSmsDevicePage from 'user/components/LinkSmsDevicePage.jsx';
import { PromptNames } from 'constants/PromptConstants';
import GroupActions from 'groups/actions/GroupActions';
import UserActions from 'user/UserActions';

const JoinConfirmSmsDevicePage = React.createClass({
  propTypes: {
    location: React.PropTypes.object.isRequired,
    params: React.PropTypes.object.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      groupCode: this.props.params.groupCode,
      address: this.props.location.query.address,
      token: this.props.location.query.token,
      name: this.props.location.query.name,
    };
  },

  onDone(device: {token: string}) {
    const onUserUpdateSuccess = user => {
      GroupActions.subscribeToGroupWithCode(this.state.groupCode).then(() => {
        this.context.router.push(user.getRole() ? '/classes?origin=subscribed' : '/join/role_picker');
      }, () => {
        this.context.router.push(`/join/role_picker/${this.state.groupCode}`);
      });
    };

    const onUserUpdateFailure = () => {
      ToastActions.showErrorToast('An error occured');
      this.context.router.push(`/join/${this.state.groupCode}`);
    };

    const onSessionExchanged = () => {
      // bypass the setup sms device setup step.
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_SMS_DEVICE);
      const human = humanparser.parseName(this.state.name);

      UserActions.update({
        prefix: human.salutation,
        last_name: human.lastName,
        first_name: human.firstName,
      }).then(onUserUpdateSuccess, onUserUpdateFailure);
    };

    Session
      .createWithToken(device.token)
      .then(onSessionExchanged)
      .catch(e => console.error('JoinConfirmSmsDevicePage onDone failed', e));
  },

  render() {
    return (
      <LinkSmsDevicePage
        {...this.state}
        onDone={this.onDone}
        instantResend
      />
    );
  },
});

export default JoinConfirmSmsDevicePage;



// WEBPACK FOOTER //
// ./src/join/components/JoinConfirmSmsDevicePage.jsx